import { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { Flex } from '@chakra-ui/react';

import type { APILeadsListResultData, APIUserData } from 'types/api.types';

import LeadAssignUser from 'views/leads/components/LeadAssignUser';
import LeadArchive from 'views/leads/components/LeadArchive';

interface UnassignedListActionsProps {
  lead: APILeadsListResultData;
  onSuccess?: () => void;
}

const UnassignedListActions = ({
  lead,
  onSuccess,
}: UnassignedListActionsProps) => {
  const queryClient = useQueryClient();

  const [isAssigned, setIsAssigned] = useState(false);
  const [isArchived, setIsArchived] = useState(false);

  const handleLeadAssigned = (user: APIUserData, brokerId: number | 'me') => {
    setIsAssigned(true);

    if (brokerId === 'me') {
      queryClient.invalidateQueries({ queryKey: ['active-lead-list'] });
    }

    if (onSuccess) onSuccess();
  };

  const handleLeadArchived = () => {
    setIsArchived(true);

    if (onSuccess) onSuccess();
  };

  return (
    <Flex justifyContent="space-between" gap={2}>
      {!isArchived && (
        <LeadAssignUser lead={lead} onSuccess={handleLeadAssigned} />
      )}

      {!isAssigned && (
        <LeadArchive lead={lead} onSuccess={handleLeadArchived} />
      )}
    </Flex>
  );
};

export default UnassignedListActions;
